import { useNavigate } from "react-router-dom";
import { ago } from "@/lib/utils";
import { Briefcase, Users, ClipboardCheck, BarChart3, MessageSquare, ArrowRight } from "lucide-react";

const KIND = {
  "Create Job": ["New role", Briefcase], "Job Builder": ["Role", Briefcase], "Find Talent": ["Find talent", Users], Pipeline: ["Candidates", Users],
  Assessment: ["Assessment", ClipboardCheck], "Question Agent": ["Assessment", ClipboardCheck], "Question Refinement": ["Question edit", ClipboardCheck],
  Analytics: ["Data", BarChart3],
};

// Recent Copilot conversations, so returning recruiters can pick up a chat from Home.
export function RecentChats({ sessions, jobs }) {
  const nav = useNavigate();
  if (!sessions?.length) return null;
  const titles = Object.fromEntries((jobs || []).map((j) => [j.id, j.title]));
  return (
    <section aria-label="Recent conversations" className="space-y-2.5 pt-3" data-testid="recent-chats">
      <div className="flex items-center justify-between gap-3 px-1">
        <h2 className="text-sm font-semibold">Continue where you left off</h2>
        <button onClick={() => nav(`/copilot/${sessions[0].id}`)} className="text-[13px] text-primary hover:underline inline-flex items-center gap-1" data-testid="recent-chats-all">
          All conversations · {sessions.length}<ArrowRight className="h-3 w-3" />
        </button>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {sessions.slice(0, 4).map((s) => {
          const role = s.job_id && titles[s.job_id];
          const [label, Icon] = role ? ["Role", Briefcase] : KIND[s.mode] || ["Copilot", MessageSquare];
          return (
            <li key={s.id} className="min-w-0">
              <button onClick={() => nav(`/copilot/${s.id}`)} data-testid={`recent-chat-${s.id}`}
                className="group w-full hs-card flex items-center gap-3 px-4 py-3 text-left hover:border-primary/40 transition-[border-color,transform] duration-200 hover:-translate-y-0.5">
                <span className="h-8 w-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0"><Icon className="h-4 w-4" /></span>
                <span className="min-w-0 flex-1 leading-tight">
                  <span className="block text-sm font-medium truncate">{role || s.title}</span>
                  <span className="block text-xs text-muted-foreground truncate">{label} · {s.status === "running" ? "working now" : ago(s.updated_at)}</span>
                </span>
                <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform]" />
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
